const punctuationMarks = '.!?'

// Ensure this sentence ends with a punctuation mark
export function renderSentence(message: string) {
  const lastChar = message.slice(-1)
  if (!punctuationMarks.includes(lastChar)) message += '.'
  return message
}
